import PropTypes from 'prop-types'
import { X } from '@phosphor-icons/react'

const VideoPreviewModal = ({ handleCloseVideo, videoUrl }) => {
  return (
    <div className="ctp-video-preview-modal">
      <div className="ctp-video-preview-modal__overlay" onClick={handleCloseVideo}>
        <div className="ctp-video-preview-modal__content" onClick={(e) => e.stopPropagation()}>
          <button className="ctp-video-preview-modal__close" onClick={handleCloseVideo}>
            <X size={24} weight="bold" />
          </button>
          <video src={videoUrl} controls autoPlay className="ctp-video-preview-modal__video" />
        </div>
      </div>
    </div>
  )
}

VideoPreviewModal.propTypes = {
  handleCloseVideo: PropTypes.func.isRequired,
  videoUrl: PropTypes.string.isRequired,
}

export default VideoPreviewModal
